// Адресаты дополнительных вопросов интервьюеров (только админские экраны).
// Нет forInterviewerIds / пустой список = вопрос не назначен никому.
export const describeQuestionTargets = (q, interviewers) => {
  const ids = Array.isArray(q && q.forInterviewerIds) ? q.forInterviewerIds : [];
  if (ids.length === 0) return 'не назначен никому';
  const names = ids.map((id) => {
    const i = (Array.isArray(interviewers) ? interviewers : []).find((x) => x.userId === id);
    return (i && i.name) || id;
  });
  return `для: ${names.join(', ')}`;
};
